/** Why something needs the boundary before it can be used. */
export const ADD_BOUNDARY_FIRST = "Add a boundary first";

/** Why FOND data can't be imported from inside the boundary. */
export const BOUNDARY_TOO_LARGE = "The boundary is too large to import FOND data from.";

/** Why an import failed once its data was downloaded. */
export const IMPORT_SAVE_ERROR = "There was a problem saving your data. Please try again.";

/** Why the boundary couldn't be saved. */
export const BOUNDARY_SAVE_ERROR = "There was a problem saving the boundary. Please try again.";

/** Why FOND data inside an area drawn or uploaded couldn't be downloaded. */
export const AREA_DOWNLOAD_ERROR = "There was a problem downloading FOND data for this area.";
